import * as EventProperties from './event-properties';
import * as ObjectProperties from './object-properties';
import * as PageProperties from './page-properties';

export default {
  EventProperties,
  ObjectProperties,
  PageProperties,
};
